import hydrateCompanies from './hydrateCompanies'

const updateCompaniesQuery = store => ({
  page,
  sortBy,
  sortDirection,
  search,
}) => {
  if (page) store.setState({companyListPage: page})
  if (sortBy) store.setState({companyListSortBy: sortBy})
  if (sortDirection) store.setState({companyListSortDirection: sortDirection})
  if (typeof search === 'string') store.setState({companyListSearch: search})

  hydrateCompanies(store)()
}

export default updateCompaniesQuery
